module.exports = {
  name: 'string', base: '_field', prototype: {
    element_selector: 'input[type=text], input:not([type])'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/string.js
 ** module id = 36
 ** module chunks = 0
 **/